import { render, staticRenderFns } from "./_base-card-detail.vue?vue&type=template&id=6581b8e6&scoped=true&"
import script from "./_base-card-detail.vue?vue&type=script&lang=js&"
export * from "./_base-card-detail.vue?vue&type=script&lang=js&"
import style0 from "./_base-card-detail.vue?vue&type=style&index=0&id=6581b8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581b8e6",
  null
  
)

export default component.exports